import React, { useState, useCallback, useEffect } from 'react';
import { Card, CardGroup } from 'react-bootstrap';
import { Icon } from '@iconify/react';
import bxsXCircle from '@iconify-icons/bx/bxs-x-circle';
import AnexoIcone from "./AnexoIcone";
import './styles.scss';
import Dropzone from 'react-dropzone-uploader'
import 'react-dropzone-uploader/dist/styles.css'
import { getDroppedOrSelectedFiles } from 'html5-file-selector'
import { warningToast } from '../DommusToast';
import Swal from 'sweetalert2';

export default function Anexos({ listaAnexos, setListaAnexos, filesTypes, multiplos=true, disabled=false, clean=false, formData=false, habilitarPreVisualizacaoImagem=true, maximoArquivos, maximoTamanhoArquivoBytes, maximoTamanhoLoteBytes=20971520 }) {
    const extensaoImagem = ['jpeg', 'jpg', 'png', 'gif', 'bmp', 'ico', 'jfif'];
    const [lista, setLista] = useState([]);

    useEffect(()=>{
        if(listaAnexos.length && listaAnexos?.length > lista?.length){
            setLista(listaAnexos)
        }
    },[listaAnexos])

    useEffect(()=>{
        if(clean && lista.length){
            setLista([]);
        }
    },[clean])

    const montaArquivo = (anexo) => {
        if(!multiplos && lista.length > 0){
            warningToast.fire("Número máximo de arquivos já adicionado!");
            return
        }
        const anexoNovo = (Array.isArray(anexo) && anexo.map(obj => (obj && obj.file) || obj)) || [anexo.file]
        const anexosPreview = [...lista]
        const removerPontosRepetidos = (str) => str.replace(/\.(?=.*\.)+/g, '');
        if(!formData) {
            anexoNovo.forEach((anexo) => {
                let separaTipo = anexo.type.split("/").pop().split(".");
                let reader = new FileReader();
                let file = new Blob([anexo], {type: anexo.type});
                file.name = removerPontosRepetidos(anexo.name);
                const extension = file.name.split('.').pop();
    
                if(Array.isArray(filesTypes) && !filesTypes.includes("." + extension)){
                    Swal.fire({
                        titleText: "Erro",
                        text: `Arquivo não é suportado. Favor inserir arquivos com as seguintes extensões: ${filesTypes.join(',')}`,
                        icon: 'error'
                    });
                    return;
                }
    
                anexosPreview.push(file)
                reader.onloadend = function (upload) {
                    const item = {
                        conteudo: upload.target.result.split(/base64,/)[1],
                        nome: file.name,
                        tipo: separaTipo[separaTipo.length - 1],
                        extensao: extension
                    }
                    setListaAnexos((current) => [...current, item]);
                };
                file && reader.readAsDataURL(file)
            })
            setLista(anexosPreview)
        } else {
            const novosArquivos = anexoNovo.map(arquivo => new File(
                [arquivo],
                removerPontosRepetidos(arquivo.name),
                { type: arquivo.type }
            ));
            const proximosArquivos = [...lista, ...novosArquivos];
            const arquivoInvalido = novosArquivos.find(arquivo => {
                const extensao = arquivo.name.split('.').pop().toLowerCase();
                return Array.isArray(filesTypes) && !filesTypes.includes(`.${extensao}`);
            });
            const arquivoGrande = maximoTamanhoArquivoBytes && novosArquivos.find(arquivo => arquivo.size > maximoTamanhoArquivoBytes);
            const tamanhoTotal = proximosArquivos.reduce((total, arquivo) => total + arquivo.size, 0);

            if (arquivoInvalido) {
                Swal.fire({
                    titleText: "Erro",
                    text: `Arquivo não é suportado. Favor inserir arquivos com as seguintes extensões: ${filesTypes.join(',')}`,
                    icon: 'error'
                });
                return;
            }

            if (maximoArquivos && proximosArquivos.length > maximoArquivos) {
                Swal.fire({
                    titleText: "Erro",
                    text: `Número máximo de arquivos excedido. Máximo permitido: ${maximoArquivos}.`,
                    icon: 'error'
                });
                return;
            }

            if (arquivoGrande) {
                Swal.fire({
                    titleText: "Erro",
                    text: `O arquivo ${arquivoGrande.name} excede o tamanho permitido de ${maximoTamanhoArquivoBytes / 1048576} MB.`,
                    icon: 'error'
                });
                return;
            }

            if (tamanhoTotal > maximoTamanhoLoteBytes) {
                Swal.fire({
                    titleText: "Erro",
                    text: 'Limite de tamanho total dos arquivos excedido.',
                    icon: 'error'
                });
                return;
            }

            setListaAnexos(proximosArquivos);
            setLista(proximosArquivos);
        }
    };

    const removeAnexo = useCallback(
        (idArquivo) => {
            const novaLista = [...listaAnexos];
            novaLista.splice(idArquivo, 1);
            setListaAnexos(novaLista);
            const novaListaFiles = [...lista];
            novaListaFiles.splice(idArquivo, 1);
            setLista(novaListaFiles);
        },
        [listaAnexos, setListaAnexos, lista]
    );

    const handleVerifyType = (file) => {
        const extensao = file?.name?.split('.').pop();
        if (extensaoImagem?.includes(extensao)) {
            return true;
        } else {
            return extensao
        }
    };

    const handleSubmit = (files) => {
        montaArquivo(files)
        files.remove()
    }

    const Input = ({ accept, onFiles, files, getFilesFromEvent, extra }) => {
        let text = 'Arraste ou click aqui para anexar arquivos'
        if(extra.reject){
            text = "Tipo de arquivo não suportado"
        }
        return (
            <label style={{ color: '#183b64', cursor: disabled ? "not-allowed": "pointer", padding: 15, borderRadius: 3, marginTop: 15}}>
                {text}
                <input
                    style={{ display: 'none' }}
                    type="file"
                    accept={accept}
                    multiple={multiplos}
                    onChange={e => {
                        getFilesFromEvent(e).then(chosenFiles => {
                            montaArquivo(chosenFiles);
                        })
                    }}
                    disabled={disabled}
                />
            </label>
        )
    }

    const getFilesFromEvent = e => {
        return new Promise(resolve => {
            getDroppedOrSelectedFiles(e).then(chosenFiles => {
                chosenFiles.forEach((file)=>{
                    if(Array.isArray(filesTypes) && !filesTypes.includes("." + file?.name?.split('.').pop())){
                        Swal.fire({
                            titleText: "Erro",
                            text: `Arquivo não é suportado. Favor inserir arquivos com as seguintes extensões: ${filesTypes.join(',')}`,
                            icon: 'error'
                        });
                        return;
                    }
                })
                resolve(chosenFiles.map(f => f.fileObject))
            })
        })
    }

    const buttonSubmit = (event) => {
        handleSubmit(event)
        return true
    }

    return <>
        <Dropzone
            onSubmit={handleSubmit}
            onChangeStatus={(file, status) => { status === 'done' && buttonSubmit(file) }}
            InputComponent={Input}
            PreviewComponent={() => <></>}
            getFilesFromEvent={getFilesFromEvent}
            SubmitButtonComponent={() => <></>}
            accept={Array.isArray(filesTypes) ? filesTypes.join(',') : filesTypes}
            styles={{
                dropzoneReject: { borderColor: 'red', backgroundColor: '#DAA' },
                inputLabel: (files, extra) => (extra.reject ? { color: 'red' } : {}),
            }}
        />
        <CardGroup>

            {
                lista && lista.map((file, index) => (
                    <Card key={index} className="anexosEmail" >
                        <Card.Img variant="top" />
                        <div>
                            <Icon className="removerAnexo" icon={bxsXCircle} onClick={() => removeAnexo(index)} color="#F44336" />
                        </div>
                        <Card.Body className="card_anexo_body">
                            <div className="corpoAnexo">
                                {habilitarPreVisualizacaoImagem && handleVerifyType(file) === true
                                    ? (<>
                                        < img className="img_upload" src={URL.createObjectURL(file)} alt={file.name} />
                                    </>
                                    )
                                    :
                                    <AnexoIcone anexo={file?.tipo ?? handleVerifyType(file)} style={{ fontSize: "5rem" }} />
                                }
                            </div>
                            <h6>
                                {file ? file?.name ?? file?.nome : " "}
                            </h6>
                        </Card.Body>
                    </Card>
                ))
            }
        </CardGroup>

    </>
}
